document.addEventListener("DOMContentLoaded", () => {
  const moveSectionsIntoContainer = (section) => {
    const sectionsCountToMove = parseInt(section.dataset.sectionCount);
    for (let i = 0; i < sectionsCountToMove; i++) {
      //Create new swiper slider element
      const slide = document.createElement('swiper-slide');

      //Append section contents to new element
      slide.appendChild(section.parentNode.parentNode.nextElementSibling);

      //Add new element as slide in our section
      section.append(slide);
    }
  };

  document.querySelectorAll(".section-slider").forEach((sectionSlider) => {
    moveSectionsIntoContainer(sectionSlider);

    //Add parameters to swiper before initializing
    Object.assign(sectionSlider, {
      loop: true,
      setWrapperSize: true,
      pagination: {
        clickable: true,
        el: sectionSlider.parentElement?.querySelector(
          ".section-slider__pagination"
        ),
      },
      navigation: {
        clickable: true,
        nextEl: sectionSlider.parentElement?.querySelector(
          ".section-slider__next"
        ),
        prevEl: sectionSlider.parentElement?.querySelector(
          ".section-slider__prev"
        ),
      },
    });
    sectionSlider.initialize();
  });
});
